// extracted by mini-css-extract-plugin
module.exports = {"fnav":"funkynav-module--fnav--2pscT","trigger":"funkynav-module--trigger--KlrI_","linkbox":"funkynav-module--linkbox--uf6HS"};